<template>
  <v-container fluid v-if="showContent === true">
    <v-data-table
      :headers="headers"
      :items="informations"
      :page.sync="pagination.current"
      :items-per-page="pagination.itemsPerPage"
      disable-pagination
      :hide-default-footer="true"
      sort-by="id"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>保險公司資訊</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <!-- 資料編輯對話框-->
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on"
                >建立新資料</v-btn
              >
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-form ref="form" lazy-validation>
                    <v-row>
                      <v-col>
                        <v-menu
                          v-model="publish_date_menu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="editedItem.publish_date"
                              :rules="[(v) => !!v || '請填寫上架日期']"
                              label="上架日期"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="editedItem.publish_date"
                            @input="publish_date_menu = false"
                            no-title
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-text-field
                          v-model="editedItem.title"
                          label="顯示標題"
                          :rules="[(v) => !!v || '請填寫顯示標題']"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-text-field
                          v-model="editedItem.link"
                          label="資料網址"
                        ></v-text-field>
                        <br />
                        <span>或</span>
                        <v-file-input
                          v-model="editedItem.file"
                          label="上傳檔案"
                          @change="handleUploadedFile"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-textarea
                          v-model="editedItem.description"
                          label="資訊內容"
                        >
                        </v-textarea>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer>{{ dialogMessage }}</v-spacer>
                <v-btn
                  :loading="loading"
                  color="blue darken-1"
                  text
                  @click="close"
                  >取消</v-btn
                >
                <v-btn
                  :loading="loading"
                  color="blue darken-1"
                  text
                  @click="save"
                  >儲存</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="headline">您確定要刪除此資料？</v-card-title>
              <v-card-text>{{ deleteDialogMessage }}</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >取消</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                  >刪除</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <!-- 資料表格 -->
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon large class="mr-2" @click="openItem(item)"
          >mdi-file-find-outline</v-icon
        >
        <v-icon large class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
        <v-icon large @click="deleteItem(item)">mdi-delete</v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="searchRecord">載入資料</v-btn>
      </template>
    </v-data-table>
    <v-pagination
      v-model="pagination.current"
      :length="pagination.total"
      @onClick="onPageChange"
    ></v-pagination>
  </v-container>
</template>
<script>
import InsuranceCompanyInformationDataService from "../../services/InsuranceCompanyInformationDataService";

export default {
  name: "insurance-company-information-datatable",
  props: {
    insurance_company_id: Number,
  },
  data() {
    return {
      headers: [
        { text: "上架日期", value: "publish_date", width: "120px" },
        {
          text: "標題",
          align: "start",
          sortable: false,
          value: "title",
          width: "200px",
        },
        {
          text: "資訊內容",
          align: "start",
          value: "description",
          sortable: false,
        },
        { text: "Action", value: "actions", sortable: false, width: "180px" },
      ],
      informations: [],
      dialog: false,
      dialogDelete: false,
      publish_date_menu: false,
      editedItem: {
        id: -1,
        insurance_company_id: this.insurance_company_id,
        publish_date: "",
        title: "",
        link: "",
        description: "",
        file_name: "",
        file_type: "",
        file: null,
      },
      editedIndex: -1,
      defaultItem: {
        id: -1,
        insurance_company_id: this.insurance_company_id,
        publish_date: "",
        title: "",
        link: "",
        description: "",
        file_name: "",
        file_type: "",
        file: null,
      },
      pagination: {
        current: 1,
        total: 0,
        itemsPerPage: 20,
      },
      dialogMessage: "",
      deleteDialogMessage: "",
      loading: false,
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "新資料" : "編輯資料";
    },
    showContent() {
      return this.insurance_company_id != -1;
    },
  },
  created() {
    this.searchRecord();
  },
  methods: {
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      if (this.$refs.form.validate()) {
        //console.log(this.editedIndex, 'save, editIndex')
        //console.log(this.loading, "save:this.loading")
        this.loading = true;
        //console.log(this.loading, "save:this.loading")
        if (this.editedIndex > -1) {
          if (this.editedItem.file == null) {
            //修改資訊
            InsuranceCompanyInformationDataService.updateInformation(
              this.editedItem.id,
              this.editedItem.title,
              this.editedItem.link,
              this.editedItem.description,
              this.editedItem.publish_date
            )
              .then((response) => {
                if (response.result === true) {
                  Object.assign(
                    this.informations[this.editedIndex],
                    this.editedItem
                  );
                  this.dialogMessage = "";
                  this.loading = false;
                  this.close();
                } else {
                  this.dialogMessage = response.message;
                }
              })
              .catch((e) => {
                this.loading = false;
                console.log(e);
              });
          } else {
            //換檔案
            InsuranceCompanyInformationDataService.uploadExistInformationFile(
              this.editedItem.id,
              this.insurance_company_id,
              this.editedItem.title,
              this.editedItem.description,
              this.editedItem.publish_date,
              this.editedItem.file
            ).then((response) => {
              if (response.result === true) {
                this.editedItem.link = response.item.link;
                this.editedItem.file_name = response.item.file_name;
                this.editedItem.file_type = response.item.file_type;
                this.editedItem.file = null;
                Object.assign(
                  this.informations[this.editedIndex],
                  this.editedItem
                );
                this.dialogMessage = "";
                this.loading = false;
                this.close();
              } else {
                this.dialogMessage = response.message;
                this.loading = false;
              }
            });
          }
        } else {
          //console.log(this.editedItem.file, 'editedItem.file')
          if (this.editedItem.file == null) {
            //沒有檔案的新增
            //新增
            InsuranceCompanyInformationDataService.createInformation(
              this.insurance_company_id,
              this.editedItem.title,
              this.editedItem.link,
              this.editedItem.description,
              this.editedItem.publish_date
            )
              .then((response) => {
                if (response.result === true) {
                  this.editedItem.id = response.item.id;
                  this.informations.push(this.editedItem);
                  this.dialogMessage = "";
                  this.loading = false;
                  this.close();
                } else {
                  this.dialogMessage = response.message;
                  this.loading = false;
                }
              })
              .catch((e) => {
                console.log(e);
              });
          } else {
            InsuranceCompanyInformationDataService.uploadNewInformationFile(
              this.insurance_company_id,
              this.editedItem.title,
              this.editedItem.description,
              this.editedItem.publish_date,
              this.editedItem.file
            ).then((response) => {
              // console.log(response, 'uploadNewInformationFile.response')
              if (response.result === true) {
                this.editedItem.id = response.item.id;
                this.editedItem.link = response.item.link;
                this.editedItem.file_name = response.item.file_name;
                this.editedItem.file_type = response.item.file_type;
                this.editedItem.file = null;
                this.informations.push(this.editedItem);
                this.dialogMessage = "";
                this.loading = false;
                this.close();
              } else {
                this.dialogMessage = response.message;
                this.loading = false;
              }
              //console.log(this.loading, "save:this.loading")
            });
          }
        }
      }
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    deleteItemConfirm() {
      //刪除資料邏輯
      InsuranceCompanyInformationDataService.deleteInformation(
        this.editedItem.id
      )
        .then((response) => {
          if (response.result === true) {
            this.informations.splice(this.editedIndex, 1);
            this.deleteDialogMessage = "";
            this.closeDelete();
          } else {
            this.deleteDialogMessage = response.message;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    openItem(item) {
      window.open(item.link);
    },
    editItem(item) {
      //console.log(item, "editItem, item")
      this.editedIndex = this.informations.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.informations.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    searchRecord() {
      //取得資料
      InsuranceCompanyInformationDataService.findByCondition(
        this.insurance_company_id,
        this.pagination.current,
        this.pagination.itemsPerPage
      )
        .then((response) => {
          //console.log(response, "searchRecord.response")
          if (response.result === true) {
            this.informations = response.list.map(this.mapData);
            this.pagination.total = response.last_page;
          } else {
            this.informations = [];
          }
        })
        .catch((e) => {
          console.log(e);
        });
      //console.log(this.informations, 'searchRecord, informations')
    },
    mapData(item) {
      //var str_description = (item.description.length > 20) ? item.description.substr(0,20) + '...' : item.description

      return {
        id: item.id,
        insurance_company_id: item.insurance_company_id,
        title: item.title,
        link: item.link,
        description: item.description,
        file_name: item.file_name,
        file_type: item.file_type,
        publish_date: item.publish_date,
      };
    },
    onPageChange() {
      this.searchRecord();
    },
    handleUploadedFile() {
      console.log(this.editedItem.file, "this.editedItem.file");
      if (this.editedItem.title == "") {
        this.editedItem.title = this.editedItem.file.name;
      }
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    insurance_company_id: function () {
      //console.log(this.insurance_company_id,'watch: insurance_company_id')
      this.searchRecord();
    },
  },
};
</script>
